export default __webpack_public_path__ + "static/media/Asset-22.7564e156.png";